var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.clean ? 'is-clean' : ''],attrs:{"id":"froalaEditor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }